import React from 'react';

// 로고 props 인터페이스
interface LogoProps {
  text?: string;           // 로고 텍스트 (기본값: 'MARU')
  width?: number;          // 로고 너비 (기본값: 139)
  height?: number;         // 로고 높이 (기본값: 34)
  className?: string;      // 추가 CSS 클래스
  onClick?: () => void;    // 클릭 이벤트 핸들러
}

// Logo 컴포넌트 정의
const Logo: React.FC<LogoProps> = ({ 
  text = 'MARU',      // 기본값 설정 (사용 안 함)
  width = 85.01,             // Figma에서 가져온 기본 너비
  height = 20,             // Figma에서 가져온 기본 높이
  className = '',
  onClick
}) => {
  // 로고 컨테이너 스타일
  const containerStyles = {
    width: width,
    height: height,
    display: 'flex' as const,
    alignItems: 'center' as const,
    justifyContent: 'center' as const,
    cursor: onClick ? 'pointer' : 'default',
    transition: 'opacity 0.2s ease',
  };

  return (
    <div 
      style={containerStyles}
      className={className}
      onClick={onClick}
      onMouseEnter={(e) => {
        if (onClick) {
          e.currentTarget.style.opacity = '0.8'; // 호버 시 투명도 조정
        }
      }}
      onMouseLeave={(e) => {
        if (onClick) {
          e.currentTarget.style.opacity = '1'; // 원래 투명도로 복원
        }
      }}
    >
      <img 
        src="/images/icons/Logo.svg" 
        alt="MARU Logo"
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'contain'
        }}
      />
    </div>
  );
};

// Logo 컴포넌트를 다른 파일에서 사용할 수 있도록 내보내기
export default Logo;
